import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { FieldArray } from "react-final-form-arrays";
import { TextField } from "@/shared/components/Form/TextField";
import type {
  PlatformBlockComponent,
  PlatformBlockProps,
} from "../../../types";
import { Stack } from "@mui/material";
import { BlockFormHeader } from "../BlockFormHeader";

export const Faq: PlatformBlockComponent = ({ name }: PlatformBlockProps) => {
  const { t } = useTranslation();

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="FAQ" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.title`}
            label={t("platformBlocks.fields.title")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={12}>
          <FieldArray name={`${name}.questions`}>
            {({ fields }) => (
              <Stack spacing={2}>
                {fields.map((fieldName, index) => {
                  return (
                    <Stack key={fieldName} direction="row" alignItems="center">
                      <Grid container spacing={2} flexGrow={1}>
                        <Grid size={6}>
                          <TextField
                            name={`${fieldName}.question`}
                            label={t("platformBlocks.faq.question")}
                            type="text"
                            fullWidth
                          />
                        </Grid>
                        <Grid size={6}>
                          <TextField
                            name={`${fieldName}.answer`}
                            label={t("platformBlocks.faq.answer")}
                            type="text"
                            fullWidth
                            multiline
                          />
                        </Grid>
                      </Grid>
                      <IconButton
                        type="button"
                        onClick={() => {
                          fields.remove(index);
                        }}
                        size="large"
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Stack>
                  );
                })}
                <Button
                  type="button"
                  variant="outlined"
                  fullWidth
                  onClick={() => fields.push({})}
                >
                  {t("platformBlocks.faq.addQuestion")}
                </Button>
              </Stack>
            )}
          </FieldArray>
        </Grid>
        <Grid size={12}>
          <TextField
            name={`${name}.maxWidth`}
            label={t("platformBlocks.fields.maxWidth")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingTop`}
            label={t("platformBlocks.fields.paddingTop")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <TextField
            name={`${name}.paddingBottom`}
            label={t("platformBlocks.fields.paddingBottom")}
            type="number"
            fullWidth
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
